import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-24 bg-gym-charcoal" data-id="element-271">
      <div className="max-w-3xl mx-auto px-4" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-273">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 uppercase tracking-wide text-gym-gold" data-id="element-274">
            El dolor que nadie quiere admitir
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed font-body" data-id="element-275">
            <p data-id="element-276">Hay una escena que se repite miles de veces en Lima.</p>
            <p data-id="element-277">
              Una persona se para frente al espejo un lunes por la mañana. Se
              mira. Suspira. Y dice:{' '}
              <span className="italic text-white font-medium" data-id="element-278">
                "Este mes sí. Este mes de verdad empiezo."
              </span>
            </p>
            <p data-id="element-279">
              Va al gym. Paga la mensualidad. Entrena 2, 3, hasta 4 semanas
              seguidas. Después... la vida pasa. El trabajo. El cansancio. La
              falta de guía.
            </p>
            <p className="text-white font-semibold" data-id="element-280">
              Y el cuerpo... sigue igual.
            </p>

            <div className="my-10 p-6 border-l-4 border-gym-green bg-gym-charcoalLight rounded-r-lg" data-id="element-281">
              <p className="text-2xl font-heading font-bold text-white uppercase tracking-wide" data-id="element-282">
                ¿Te suena familiar?
              </p>
            </div>

            <p data-id="element-283">No te culpes. Porque el problema no eres tú.</p>
            <p className="text-2xl font-bold text-white mt-4" data-id="element-284">
              El problema es que has estado usando un sistema roto.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}